<template functional>
  <div class="skeletonShimmer__template">

    <div class="pulse">
      <div class="skeletonShimmer__circle"/>
      <div class="skeletonShimmer__paragraph"/>
      <div class="skeletonShimmer__paragraph"/>

      <div class="skeletonShimmer__radioList">
        <div class="skeletonShimmer__radio">
          <div class="skeletonShimmer__input"/>
          <div class="skeletonShimmer__label"/>
        </div>

        <div class="skeletonShimmer__radio">
          <div class="skeletonShimmer__input"/>
          <div class="skeletonShimmer__label"/>
        </div>

        <div class="skeletonShimmer__radio">
          <div class="skeletonShimmer__input"/>
          <div class="skeletonShimmer__label"/>
        </div>
      </div>
    </div>

    <div class="skeletonShimmer__buttons pulse">
      <div class="skeletonShimmer__button"/>
      <div class="skeletonShimmer__span"/>
    </div>

    <slot />
  </div>
</template>

<script>
export default {
  name: 'SkeletonSelectPhoneNumber',
};
</script>
